<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      @md-opened="openDialog"
      @md-clicked-outside="closeDialog"
      @md-closed="closeDialog"
    >
      <md-dialog-title>Add new admin</md-dialog-title>
      <div class="md-dialog-content md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <form>
          <md-field class="md-layout-item md-small-size-100 md-size-100" :class="errors.invalidClasses.username">
            <label> Username </label>
            <md-input v-model="username"></md-input>
            <ValidationError :errors="errors.messages.username" />
          </md-field>
          <md-field class="md-layout-item md-small-size-100 md-size-100" :class="passwordErrorsClass">
            <label> Password </label>
            <md-input v-model="password" type="password" required autocomplete="off"></md-input>
            <ValidationError :errors="errors.messages.password" />
            <span class="md-error">{{ passwordError }}</span>
          </md-field>
          <label class="admin-permission"> Admin Permissions</label>
          <div :class="groupsErrorsClass">
            <div class="md-layout-item md-layout md-gutter md-small-size-100 md-size-100">
              <div class="md-layout-item md-small-size-50 md-size-50 no-padding">
                <md-checkbox v-model="adminGroups" value="application_admins">Application Permission</md-checkbox>
              </div>
              <div class="md-layout-item md-small-size-50 md-size-50 no-padding">
                <md-checkbox v-model="adminGroups" value="server_admins">Server Permission</md-checkbox>
              </div>
              <div class="md-layout-item md-small-size-50 md-size-50 no-padding">
                <md-checkbox v-model="adminGroups" value="viewer_admins">ReadOnly Permission</md-checkbox>
              </div>
            </div>
            <ValidationError :errors="errors.messages.groups" class="md-error-permissions"/>
            <span class="md-error md-error-permissions">{{ adminGroupsError }}</span>
          </div>
        </form>
        <div class="md-layout-item md-size-100 text-right">
          <md-button @click="closeDialog">Close</md-button>
          <md-button class="md-primary" @click="addNewAdmin">Add</md-button>
        </div>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import apiManager from "@/api-manager";
import NotificationStore from "../components/NotificationPlugin/NotificationStore";
import ValidationError from "./ValidationError.vue"

export default {
  name: "CreateNewAdmin",
  props: ["show"],
  components:{
    ValidationError
  },
  setup: (props, { emit }) => {
    const openDialog = () => {
      clearInputs();
      resetErrors();
    };
    const closeDialog = () => {
      emit("close");
    };

    const username = ref("");
    const password = ref("");
    const adminGroups = ref([]);

    const errors = ref({
      invalidClasses: "",
      messages: ""
    });
    const hasPasswordClass = ref(false);
    const hasAdminGroupsClass = ref(false);

    const adminGroupsError = ref("");
    const passwordError = ref("");

    const addNewAdmin = async () => {
      resetErrors();
      if (password.value.trim() === "") {
        hasPasswordClass.value = true;
        passwordError.value = "This password is empty or entirely spaces.";
        return;
      }
      if (adminGroups.value.length === 0) {
        // At least you should select one admin group
        hasAdminGroupsClass.value = true;
        adminGroupsError.value = "You should select at least one admin permission.";
        return;
      }
      const response = await apiManager.createAdmin({
        params: {
          username: username.value,
          password: password.value,
          groups: adminGroups.value,
        },
      });
      if (response.status === 200) {
        NotificationStore.notify({
          message: response.parsedData.message,
          icon: "add_alert",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        emit("created", response.parsedData.message);
      } else if (response.status === 400) {
        errors.value = response.processed_errors;
        return;
      } else {
        NotificationStore.notify({
          message: response.parsedError,
          icon: "error",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "error",
        });
        emit("failed", response.parsedError);
      }
      closeDialog();
    };

    const resetErrors = () => {
      errors.value = {
        invalidClasses: "",
        messages: ""
      }
      hasPasswordClass.value = false;
      hasAdminGroupsClass.value = false;
      passwordError.value = "";
      adminGroupsError.value = "";
    };
    const clearInputs = () => {
      username.value = "";
      password.value = "";
      adminGroups.value = [];
    };

    const passwordErrorsClass = computed(() => {
      if(errors.value.invalidClasses.password) {
        return errors.value.invalidClasses.password;
      }
      if (hasPasswordClass.value) {
        return 'md-invalid';
      }
    });

    const groupsErrorsClass = computed(() => {
      if(errors.value.invalidClasses.groups) {
        return errors.value.invalidClasses.groups;
      }
      if (hasAdminGroupsClass.value) {
        return 'md-invalid';
      }
    });

    return {
      openDialog,
      closeDialog,
      username,
      password,
      adminGroups,
      hasPasswordClass,
      hasAdminGroupsClass,
      adminGroupsError,
      passwordError,
      addNewAdmin,
      errors,
      passwordErrorsClass,
      groupsErrorsClass
    };
  },};
</script>

<style lang="scss" scoped>
.admin-permission {
  font-weight: 400;
  color: #aaa;
}

.md-error.md-error-permissions {
  color: #ff1744;
  font-size: 12px;
  bottom: 12px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateZ(0);
  position: relative;
}

.md-layout.md-gutter > .md-layout-item.no-padding {
  padding: 0;
}
</style>
